import React, { useState, useEffect } from "react"
import { useGlobalContext } from "../data/GlobalContext"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import LoginGlobal from "../data/LoginGlobal"
export default function EasterEgg() {
  const data = promotionsData.find((promo) => promo.title === "Easter Egg Drop")
  const { setShowEasterEgg } = useGlobalContext()
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Easter Egg Drop</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>FGH Easter Egg Drop Bonanza 2025!</h1>
                <h2>Catch Your Luck and Win Free Credits!</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period : </strong>
                  <span>
                    April 17, 2025 (12:00 PM) – May 16, 2025 (11:59AM)
                  </span>
                </div>
              </div>

              <div className="promotion-tnc-mechanic-content">
                <strong>1. Deposit-Based Chances - All Players : </strong>
                <ol>
                  <li>
                    Players can unlock additional chances by making deposits:
                  </li>
                  <li>
                    Deposit Requirements:
                    <ol style={{ listStyleType: "disc" }}>
                      <li>
                        Deposit PHP 200: Unlocks the 1st chance with 30 seconds
                        to play.
                      </li>
                      <li>
                        Next Deposit of PHP 500: Unlocks the 2nd chance with 30
                        seconds to play.
                      </li>
                      <li>
                        Maximum Chances per Day: 2 chances (both deposit-based).
                      </li>
                    </ol>
                  </li>
                </ol>
                <strong>2. Gameplay Mechanics : </strong>
                <ol>
                  <li>
                    Objective: Control the bunny to catch falling eggs and avoid
                    bombs.
                  </li>
                </ol>
                <strong>3. Scoring System :</strong>
                <ol>
                  <li>
                    Special Egg 🥚: 2x - 200x multiplier (can be achieved once
                    your turnover reaches 1000 and above on our casino site.)
                  </li>
                  <li>Regular Egg 🥚: 1 free credit.</li>
                  <li>Bomb 💣: Deducts 1 free credit.</li>
                </ol>
                <strong>
                  Example: Total credits - Bombs + Golden Egg equivalent
                </strong>
                <ol style={{ listStyleType: "disc" }}>
                  <li>30 Regular Eggs: 30 x 1 = 30credits.</li>
                  <li>5 Special Eggs: 3x = 15 credits.</li>
                  <li>8 Bombs: 8 x (-1) = -8 credits.</li>
                  <li>Total Earned: 30 + 15 - 8 = 37 credits per session.</li>
                </ol>
                <strong>
                  4. Earned Free Credits must be wagered 1x on any game before
                  any withdrawal.
                </strong>
                <div className="promotion-tnc-cta">
                  {isLoggedIn ? (
                    <a
                      onClick={() => setShowEasterEgg(true)}
                      className="promotion-cta-btn"
                      style={{ cursor: "pointer" }}
                    >
                      Play Now
                    </a>
                  ) : (
                    <LoginGlobal
                      label="Play Now"
                      btnClass="promotion-cta-btn"
                      onlyBtn={true}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
